import { Fragment, ReactElement } from 'react';
import ResearchMarriageNonResidentNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-marriage-non-resident';

const ResearchMarriageNonResidentNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchMarriageNonResidentNotificationsCivilStatusShared />
    </Fragment>
  );
};

ResearchMarriageNonResidentNotificationsCivilStatusPage.displayName =
  'Research Marriage Non Resident Notifications CivilStatusPage component';

export default ResearchMarriageNonResidentNotificationsCivilStatusPage;
